import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomergroupService } from 'src/app/services/customergroup.service';

@Component({
  standalone: false,
  selector: 'app-remove-modal-customerservice-user',
  templateUrl: './remove-modal-customerservice-user.component.html',
  styleUrls: ['./remove-modal-customerservice-user.component.scss'],
})
export class RemoveModalCustomerserviceUserComponent implements OnInit {
  @Input() userId: string;
  @Input() userName: string;
  @Input() groupId: any;
  @Input() fromDetailsPage: any;

  myForm!: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private router: Router,
    private customergroupService: CustomergroupService
  ) {
    this.myForm = this.formBuilder.group({
      deletedBy: '',
      userId: ''
    });
  }

  ngOnInit(): void { }

  deleteServiceUser() {
    if (this.groupId == null) {
      this.customergroupService
        .removeCustomerServiceUser(this.userId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            if(this.fromDetailsPage == 'Yes') {
              this.router.navigate(['/list-customer-service-user/']);
            } else {
              location.reload();
            }
          }
        });
      this.modal.dismiss();
    } else {
      this.customergroupService
        .removeCustomerServiceUserOnlyFromGroup(this.userId, this.groupId)
        .subscribe((res) => {
          console.log(res);
          if (res.isValid) {
            location.reload();
          }
        });
      this.modal.dismiss();
    }

  }
}
